module.exports = __webpack_public_path__ + "img/047-dominican-republic.b384800c.svg";